import { Table } from "components";
import { useProductFilter } from "hooks";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";

export default function OldStocks() {
    const catalogue = useAppSelector((state: RootState) => state.catalogues);

    const columns = [
        {
            Header: "Name",
            accessor: "name",
            defaultCanSort: true,
            width: 200,
            Cell: (row: any) => row.value,
        },
        {
            Header: "Promo Type",
            accessor: "type",
            defaultCanSort: true,
            width: 200,
            Cell: (row: any) => <>
                {row.value === 0 && "Buy X for $"}
                {row.value === 1 && "Buy X or more get % off"}
            </>
        },
        {
            Header: "X",
            accessor: "quantity",
            defaultCanSort: true,
            width: 200,
            Cell: (row: any) => row.value,
        },
        {
            Header: "Value",
            accessor: "value",
            defaultCanSort: true,
            width: 200,
            Cell: (row: any) => row.value,
        }
    ];

    return (
        <Row>
            <Col xs={12} style={{height: "60dvh"}}>
                <Table
                    pageSize={100}
                    isSortable={true}
                    autoHeight
                    pagination={true}
                    isSearchable={true}
                    columns={columns}
                    data={catalogue.model.catalogueStocks}
                    // reloadTableRows={reLoadTable}
                    loading={catalogue.loadingStocks}
                />
            </Col>
        </Row>
    );
}